<template>
  <div class="h-screen w-screen fixed inset-0 z-[100]">
    <slot />
  </div>
</template>